// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HH66D","menu":"styles_menu__1NoKp","menu__hasMargin":"styles_menu__hasMargin__BG27w"};